import { createDelegator, animate } from "./domHelpers"

export default function ProductDetails(node) {
  node.addEventListener("click", createDelegator(".product-details-thumb", (e) => {
    e.preventDefault()

    const index = parseInt(e.delegateTarget.getAttribute("data-index"))
    node.querySelector(".product-details-image-slider").slideTo(index)
  }))

  const size = node.querySelector(".product-details-size-select-radio:not([disabled])")
  if (size) size.checked = true

  node.addEventListener("click", createDelegator(".product-details-size-select-radio:disabled + .product-details-size-select-label", async (e) => {
    if (e.target.closest("a")) return

    const info = e.delegateTarget.querySelector(".product-details-size-select-label-info")
    if (!info) return

    animate(info, "is-blinking")
  }))
}
